<template>
  <div class="pt-3">
    <template v-if="!!c_userId">
      <div v-if="inactive && Object.keys(c_slides).length">
        <SlideShow
          @done="slideShowComplete"
          :visible="Boolean(inactive && Object.keys(c_slides).length)"
        />
      </div>
      <v-row>
        <h3 class="company-header">
          {{ getNestedValue(c_company, "name", "") }}
        </h3>
        <v-flex class="xs12">
          <v-simple-table
            :items="c_bookings"
            disable-pagination
            class="display alignment-table"
          >
            <thead>
              <tr :style="{ width: '100%' }">
                <template v-for="header in headers">
                  <th
                    v-if="!c_getColumnSettings[header.value]"
                    :key="header.text"
                    :style="{ 'background-color': '#148dff', color: '#FFF' }"
                  >
                    {{ header.text }}
                  </th>
                </template>
              </tr>
            </thead>
          </v-simple-table>
          <v-simple-table
            :items="c_bookings"
            disable-pagination
            class="display alignment-table tableborder"
          >
            <tbody class="dataBody">
              <tr
                :style="{ width: '100%' }"
                v-for="record in showingTodaysBookings
                  ? c_todaysBookings
                  : c_bookings"
                :key="record.id"
              >
                <td v-if="!c_getColumnSettings.name">
                  {{ record.name ? record.name : record.userId.firstName }}
                </td>
                <td v-if="!c_getColumnSettings.time">
                  {{ record.services[0] ? record.services[0].time : "" }}
                </td>
                <td v-if="!c_getColumnSettings.employee">
                  <v-row justify="center">
                    <img
                      class="profile-image mr-2"
                      :src="record.services[0].employeeId.userId.profile_img"
                    />
                    <div :style="{ 'align-self': 'center' }">
                      {{
                        record.services[0]
                          ? record.services[0].employeeId.userId.firstName
                          : ""
                      }}
                    </div>
                  </v-row>
                </td>
                <td v-if="!c_getColumnSettings.seat">
                  {{
                    getNestedValue(
                      record.services[0],
                      ["companyEmployee", "seat"],
                      ""
                    )
                  }}
                </td>
                <td v-if="!c_getColumnSettings.category">
                  {{
                    record.services[0] ? record.services[0].serviceId.name : ""
                  }}
                </td>
                <td v-if="!c_getColumnSettings.status">
                  {{ c_statusMap[record.status] }}
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-flex>
        <v-flex class="xs4"></v-flex>
      </v-row>
    </template>
    <template v-else>
      <LoginScreen />
    </template>
  </div>
</template>

<script>
const moment = require("moment-timezone");
const { getNestedValue } = require("../functions/objectMethods");
export default {
  data() {
    return {
      device_id: 123,
      user_id: undefined,
      headers: [
        {
          value: "name",
        },
        {
          value: "time",
        },
        {
          value: "employee",
        },
        {
          value: "seat",
        },
        {
          value: "category",
        },
        {
          value: "status",
        },
      ],
      timerId: undefined,
      inactivityTimeout: undefined,
      inactive: undefined,
      showingTodaysBookings: false,
    };
  },
  computed: {
    c_userId() {
      return this.$store.getters["userId"];
    },
    c_company() {
      return this.$store.getters["company"];
    },
    c_statusMap() {
      return this.$store.getters["getLabelByKey"]("statusMap", this.c_language);
    },
    c_language() {
      return this.$store.getters["primaryLanguage"];
    },
    c_showEntireDaysBookings() {
      return this.$store.getters["showEntireDaysBookings"];
    },
    c_ad() {
      return this.$store.getters["getAd"];
    },
    c_getColumnSettings() {
      return this.$store.getters["getColumnSettings"];
    },
    c_todaysBookings() {
      return this.$store.getters["getTodaysBookings"] || [];
    },
    c_bookings() {
      return this.$store.getters["getFilteredBookings"] || [];
    },
    c_slides() {
      return this.$store.getters["getSlides"];
    },
  },
  methods: {
    buildHeaders() {
      this.headers = this.headers.map((header) => {
        return {
          text: this.$store.getters["getLabelByKey"](
            header.value,
            this.c_language
          ),
          value: header.value,
        };
      });
    },
    createInactivityTimeout() {
      clearTimeout(this.inactivityTimeout);
      this.$nextTick(() => {
        this.inactivityTimeout = setTimeout(async () => {
          if (Object.keys(this.c_slides).length) {
            this.inactive = true;
          } else {
            this.showTodaysBookings();
          }
        }, 45000);
      });
    },
    showTodaysBookings() {
      if (this.c_showEntireDaysBookings) {
        clearTimeout(this.showTodaysBookingTimeout);
        this.showingTodaysBookings = true;
        this.$nextTick(() => {
          this.showTodaysBookingTimeout = setTimeout(() => {
            this.showingTodaysBookings = false;
            this.createInactivityTimeout();
          }, 15000);
        });
      } else {
        this.createInactivityTimeout();
      }
    },
    getNestedValue,
    slideShowComplete() {
      this.inactive = false;
      this.showTodaysBookings();
    },
  },
  created() {
    setInterval(this.$store.dispatch("filterBookingsByTime"), 300000);
  },
  watch: {
    c_bookings: {
      immediate: true,
      async handler() {
        this.inactive = false;
        this.showingTodaysBookings = false;
        this.createInactivityTimeout();
        clearTimeout(this.showTodaysBookingTimeout);
      },
    },
    c_slides: {
      immediate: true,
      async handler() {
        this.inactive = false;
        this.showingTodaysBookings = false;
        this.createInactivityTimeout();
      },
    },
    c_userId: {
      immediate: true,
      async handler() {
        const self = this;
        if (self.c_userId) {
          this.$store.dispatch("getLiveSettings");
          this.buildHeaders();
          const channel = await self.$store
            .dispatch("subscribe", {
              channel: self.c_userId,
            })
            .then(() => {
              this.buildHeaders();
              self.$nextTick(() => {
                var rows = document.querySelectorAll(".dataBody tr");
                if (rows && rows.length) {
                  const scrollFunc = (previousIndex) => {
                    this.timerId = setTimeout(() => {
                      rows[previousIndex].scrollIntoView({
                        behavior: "smooth",
                        block: "start",
                      });
                      if (previousIndex + 10 > rows.length) {
                        scrollFunc(0);
                      } else {
                        scrollFunc(previousIndex + 10);
                      }
                      clearTimeout(this.timerId);
                    }, 5000);
                  };
                  scrollFunc(0);
                }
              });
            });
        }
      },
    },
    c_language: {
      immediate: true,
      handler() {
        this.buildHeaders();
      },
    },
  },
};
</script>

<style>
.v-data-table table {
  table-layout: fixed;
}
.v-data-table td,
.v-data-table th {
  font-size: 1.2em !important;
  text-align: center !important;
}
.display {
  max-height: 90vh;
  overflow-y: scroll;
}
::-webkit-scrollbar,
.v-data-table__wrapper::-webkit-scrollbar {
  display: none !important;
  width: 0px;
  background: transparent;
}
.v-data-table__wrapper {
  max-height: 80vh !important;
  overflow-y: scroll;
}
.v-data-table__wrapper table tbody tr:nth-child(odd) {
  background-color: #f2f2f2;
}
.v-data-table__wrapper table tr {
  height: 3.2vh;
}
.v-data-table td {
  height: 3.2vh;
  font-size: 1.1rem !important;
  font-weight: 550;
}
.v-data-table__wrapper table tbody {
  max-height: 80vh !important;
  overflow-y: scroll;
  width: 100%;
}
.v-data-table::-webkit-scrollbar {
  display: none !important;
}
.alignment-table {
  margin: 0 5%;
}
.tableborder {
  border: 1px rgba(0, 0, 0, 0.15) solid;
  border-radius: 0;
}
.profile-image {
  height: 32px;
  max-width: 32px;
  border-radius: 1000%;
}
.visible {
  visibility: visible;
  opacity: 1;
  transition: opacity 1s linear;
}
.hidden {
  visibility: hidden;
  opacity: 0;
  transition: visibility 0s 1s, opacity 1s linear;
}
.company-header {
  width: 100%;
  justify-content: center;
  display: flex;
  padding-bottom: 8px;
  font-size: 32px;
  font-weight: 800;
}
</style>
